import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getBookingDetail, refreshPaymentStatusApi } from '../../api/sportaloka-client';
import { getHistoryContent, getStatusColor, getStatusLabel } from '../../helpers/status';
import { format } from 'date-fns';
import BookingHistory from './components/BookingHistory';
import Swal from 'sweetalert2';

const BookingDetail = () => {
  const { id } = useParams();
  const [initLoading, setInitLoading] = useState();
  const [initError, setInitError] = useState();
  const [data, setData] = useState(null);
  const [histories, setHistories] = useState([]);
  const [selectedTab, setSelectedTab] = useState('informasi-pesanan');

  const getData = async () => {
    try {
      setInitError(false);
      setInitLoading(true);
      const response = await getBookingDetail(id);
      const responseData = response.data.data;
      const bookingHistories = responseData.booking_histories.map((item) => {
        return getHistoryContent(item);
      });
      setData(responseData);
      setHistories(bookingHistories);
      setInitLoading(false);
    } catch (error) {
      setInitError(true);
      setInitLoading(false);
    }
  };

  const refreshPaymentStatus = async () => {
    try {
      setInitLoading(true);
      await refreshPaymentStatusApi(id);
      await getData();
      setInitLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setInitLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleResetData = async () => {
    await getData();
  };

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Detail Pesanan</h1>
          <div className="d-flex">
            <Link to="/bookings" className="button -sm px-3 bg-white h-50 text-dark mr-10">
              <i className="fa fa-arrow-left mr-10" />
              Kembali
            </Link>

            <div className="d-flex">
              {data &&
                (data.status !== 'DONE' ||
                  data.status !== 'PAID' ||
                  data.status !== 'EXECUTION' ||
                  data.status !== 'REFUND' ||
                  data.status !== 'REFUND_DONE' ||
                  data.status !== 'REFUND_REJECTED' ||
                  data.status !== 'CANCELLED' ||
                  data.status !== 'REJECTED') && (
                  <button
                    disabled={initLoading}
                    onClick={refreshPaymentStatus}
                    className="button btn-sm px-3 bg-blue-1 h-50 text-white mr-10">
                    <i className="fa fa-refresh text-16 mr-10" />
                    Perbarui Status Pembayaran
                  </button>
                )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <BookingHistory
              data={histories}
              initLoading={initLoading}
              initError={initError}
              retry={getData}
            />
          </div>
          <div className="col-9">
            <div
              className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20"
              style={{ minHeight: 540 }}>
              {initLoading && !initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100"
                  style={{ minHeight: 540 }}>
                  <div className="loader" />
                  <div className="fw-600" style={{ marginLeft: 12 }}>
                    Loading...
                  </div>
                </div>
              )}
              {!initLoading && initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100 text-center"
                  style={{ minHeight: 540 }}>
                  <p className="fw-600">
                    Gagal! Periksa koneksi internet anda dan{' '}
                    <span className="text-danger cursor-pointer" onClick={getData}>
                      Coba lagi
                    </span>
                  </p>
                </div>
              )}
              {!initLoading && !initError && (
                <div>
                  <div className="custom-tabs">
                    <div
                      className={selectedTab === 'informasi-pesanan' ? 'active' : ''}
                      onClick={() => setSelectedTab('informasi-pesanan')}>
                      Informasi Pemesanan
                    </div>
                    {data &&
                      (data.status === 'PAID' ||
                        data.status === 'DONE' ||
                        data.status === 'EXECUTION') && (
                        <div
                          className={selectedTab === 'pelaksanaan-biaya' ? 'active' : ''}
                          onClick={() => setSelectedTab('pelaksanaan-biaya')}>
                          Pelaksanaan
                        </div>
                      )}
                  </div>
                  {selectedTab === 'informasi-pesanan' && (
                    <div>
                      <div>
                        <h5 className="fw-700 text-blue-1 text-18">Detail Pesanan</h5>
                        <table className="table table-striped mt-20">
                          <tbody>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Kode Booking
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                {data && data.booking_code}
                              </th>
                            </tr>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Nama Tenant
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                <a
                                  href={`/tenants/detail/${data ? data.package.tenant.id : ''}`}
                                  target="_blank"
                                  className="text-primary text-underline cursor-pointer fw-600"
                                  rel="noreferrer">
                                  {data && data.package.tenant.site_name}
                                </a>
                              </th>
                            </tr>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Nama Paket
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                {data && data.package.name_id}
                              </th>
                            </tr>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Tanggal Pemesanan
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                {data && format(data.booked_on_date, 'dd/MM/yyyy hh:mm')}
                              </th>
                            </tr>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Tanggal Pelaksanaan
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                {data && format(data.booked_for_date, 'dd/MM/yyyy')}
                              </th>
                            </tr>
                            {data && data.status === 'RESCHEDULED' && (
                              <tr>
                                <td className="px-3 py-2" width="30%">
                                  Tanggal Penjadwalan Ulang
                                </td>
                                <td className="px-3 py-2" width="5%">
                                  :
                                </td>
                                <th className="text-right px-3 py-2 text-14">
                                  {data && format(data.reschedule_date, 'dd/MM/yyyy')}
                                </th>
                              </tr>
                            )}
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Status Pesanan
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                <span
                                  className={`px-2 py-1 rounded-1 fw-600 ${data && getStatusColor(data.status)}`}>
                                  {data && getStatusLabel(data.status)}
                                </span>
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="mt-50">
                        <h5 className="fw-700 text-blue-1 text-18">Detail Pemesan</h5>
                        <table className="table table-striped mt-20">
                          <tbody>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Nama Pemesan
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                {data && data.user.fullname}
                              </th>
                            </tr>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Email Pemesan
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                {data && data.user.email}
                              </th>
                            </tr>
                            <tr>
                              <td className="px-3 py-2" width="30%">
                                Telepon Pemesan
                              </td>
                              <td className="px-3 py-2" width="5%">
                                :
                              </td>
                              <th className="text-right px-3 py-2 text-14">
                                {data && data.user.phone_number}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="mt-50">
                        <h5 className="fw-700 text-blue-1 text-18">Detail Tamu</h5>
                        <table className="table table-striped mt-20">
                          <thead>
                            <tr>
                              <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Nama Lengkap
                              </th>
                              <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Jenis Tamu
                              </th>
                              <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Umur (Tahun)
                              </th>
                              <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Berat (Kg)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data.guests.map((guest) => {
                                return (
                                  <tr key={guest.id}>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.fullname}
                                    </td>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.type === 'LOCAL' ? 'Lokal' : 'Wisman'}
                                    </td>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.age}
                                    </td>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.weight}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {selectedTab === 'pelaksanaan-biaya' && (
                    <div>
                      <div>
                        <h5 className="fw-700 text-blue-1 text-18">Pelaksanaan Tamu</h5>
                        <table className="table table-striped mt-20">
                          <thead>
                            <tr>
                              <th
                                width="30%"
                                className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Nama Lengkap
                              </th>
                              <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Jenis Tamu
                              </th>
                              <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Status
                              </th>
                              <th className="px-3 py-3 text-14 fw-700 bg-blue-1 text-white rounded-0">
                                Tanggal Reschedule
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data.guests.map((guest) => {
                                return (
                                  <tr key={guest.id}>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.fullname}
                                    </td>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.type === 'LOCAL' ? 'Lokal' : 'Wisman'}
                                    </td>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.guest_costs.length > 0 ? 'DONE' : guest.status}
                                    </td>
                                    <td className="px-3 py-3 text-14 fw-700 rounded-0">
                                      {guest.rescheduled_at
                                        ? format(guest.rescheduled_at, 'dd/MM/yyyy')
                                        : '-'}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingDetail;
